// src/modules/app-views/_apps/appmulti/operators/pages/Init/components/tableColumns/apiColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag, Tooltip } from 'antd';
import { TbPlugConnectedX, TbPlugConnected } from 'react-icons/tb';
import { PiPlugsConnectedBold } from 'react-icons/pi';
import translateX from 'utils/translateX';
import operatorsService from 'modules/app-views/_apps/appmulti/operators/service';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function apiColumn(buildColumnProps, options = {}) {
  const {
    key = 'api',
    title = 'api',
    dataIndex = '_integrations.apiEnabled',
    width = 80,
    align = 'center',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    align,
    ...buildColumnProps(dataIndex, columnProps),
    sorter: (a, b) => getApiPriority(a) - getApiPriority(b),
    render: (_, r) => {
      const cnpjValue =
        r?.documents?.find(d => d.documentType === 'cnpj')?.value ||
        r?.cnpj?.value ||
        '';
      const hasApiMatch = !!operatorsService.resolveProviderByCnpj(cnpjValue);
      const apiEnabled = r?._integrations?.apiEnabled;
      const hasCredentials = !!(
        r?._integrations?.apiCredentials?.login && r?._integrations?.apiCredentials?.password
      );

      const tag = buildApiTag(hasApiMatch, apiEnabled, hasCredentials);

      return (
        <Tooltip title={tag.tooltip}>
          <Tag
            color={tag.color}
            icon={tag.icon}
            style={{
              margin: 0,
              fontSize: 10,
              lineHeight: '16px',
              padding: '0 4px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 2,
            }}
          >
            {tag.label}
          </Tag>
        </Tooltip>
      );
    },
  };
}

export default apiColumn;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function getApiPriority(r) {
  const cnpjValue =
    r?.documents?.find(d => d.documentType === 'cnpj')?.value || r?.cnpj?.value || '';
  const hasApiMatch = !!operatorsService.resolveProviderByCnpj(cnpjValue);
  const apiEnabled = r?._integrations?.apiEnabled;
  const hasCredentials = !!(
    r?._integrations?.apiCredentials?.login && r?._integrations?.apiCredentials?.password
  );
  if (hasApiMatch && apiEnabled && hasCredentials) return 2;
  if (hasApiMatch) return 1;
  return 0;
}

function buildApiTag(hasApiMatch, apiEnabled, hasCredentials) {
  if (!hasApiMatch) {
    return {
      color: 'red',
      icon: <TbPlugConnectedX style={{ fontSize: 12 }} />,
      label: translateX('no_api'),
      tooltip: translateX('no_api_integration'),
    };
  }

  if (apiEnabled && hasCredentials) {
    return {
      color: 'blue',
      icon: <PiPlugsConnectedBold style={{ fontSize: 12 }} />,
      label: 'API',
      tooltip: translateX('api_connected'),
    };
  }

  return {
    color: 'gold',
    icon: <TbPlugConnected style={{ fontSize: 12 }} />,
    label: 'API',
    tooltip: translateX('api_disconnected'),
  };
}
